import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Contactus from '../Components/Contactus/Contactus'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Common/Header'
import Service from "../Components/Services/Index";
import { useSelector } from 'react-redux'

function Services() {
      const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <>
    <Navbar/>

        <div className={"serviceContainer"}>
      <Header title={currentLocal.general.services} />
      <Service state={true} />
    </div>
    <Contactus/>
    <Footer/>
      
    </>
  )
}

export default Services
